module.exports = __webpack_public_path__ + "media/images/unsplash_img-p-1080-6ebeb0838bde39e94acbf3c5cf291a54.jpeg";